import React from "react";

import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/Core/ErrorBoundary/ErrorBoundary";
import RouteNotFound from "./components/Core/RouteNotFound/RouteNotFound";
import SaleDetail from "./screens/Sales/Detail/SaleDetail";



//importamos las pantallas que se veran en la aplicacion
const Login = React.lazy(() => import("./screens/Login/Login"));
const Dashboard = React.lazy(() => import("./screens/Dashboard/Dashboard"));
const Home = React.lazy(() => import("./screens/Home/Home"));
const Products = React.lazy(
  () => import("./screens/Configuration/Products/Products"),
);
const MyBusiness = React.lazy(() => import("./screens/MyBusiness/MyBusiness"));
const MyVenues = React.lazy(() => import("./screens/MyVenues/MyVenues"));
const SalesOrders = React.lazy(() => import("./screens/Sales/Sales"));
const Cuts = React.lazy(() => import("./screens/Cuts/Cuts"));
const Deposits = React.lazy(
  () => import("./screens/Configuration/Payouts/Payouts"),
);
const RecoveryPassword = React.lazy(
  () => import("./screens/RecoveryPassword/RecoveryPassword"),
);
const SelectBussines = React.lazy(
  () => import("./screens/MyBusiness/MyBusiness"),
);

const Profile = React.lazy(
  () => import("./screens/Configuration/Profile/Profile"),
);
const SalesPoints = React.lazy(
  () => import("./screens/Configuration/SalesPoints/SalesPoints"),
);

const Events = React.lazy(() => import("./screens/SuperAdmin/Events/Events"));

const Clients = React.lazy(
  () => import("./screens/SuperAdmin/Clients/Clients"),
);

const Concessions = React.lazy(
  () => import("./screens/SuperAdmin/Concessions/Concessions"),
);

const UsersList = React.lazy(() => import("./screens/Users/Users"));

const ConcessionUsers = React.lazy(() => import("./screens/Users/Users"));

const VenueUsers = React.lazy(() => import("./screens/VenueUsers/VenueUsers"));

const SalesDetail = React.lazy(
  () => import("./screens/Sales/Detail/SaleDetail"),
);

const TopProducts = React.lazy(
  () => import("./screens/TopProducts/TopProducts"),
);

const TopSellers = React.lazy(() => import("./screens/TopSellers/TopSellers"));

const TopConcessions = React.lazy(
  () => import("./screens/TopConcessions/TopConcessions"),
);
const Seasons = React.lazy(
  () => import("./screens/SuperAdmin/Seasons/Seasons"),
);

const Atms = React.lazy(() => import("./screens/SuperAdmin/Atms/Atms"));
const CreateAtm = React.lazy(
  () => import("./screens/SuperAdmin/Atms/Create/CreateAtm"),
);

const Discounts = React.lazy(
  () => import("./screens/Configuration/Discounts/Discounts"),
);

const Promotions = React.lazy(
  () => import("./screens/Configuration/Promotions/Promotions"),
);

const Combos = React.lazy(
  () => import("./screens/Configuration/Combos/Combos"),
);

const YoshiSummary = React.lazy(
  () => import("./screens/Reports/YoshiSummary/YoshiSummary"),
);

const YoshiSummaryEventDetail = React.lazy(
  () =>
    import("./screens/Reports/YoshiSummary/EventDetail/EventDetail"),
);

const AtmsReport = React.lazy(() => import("./screens/AtmsReport/AtmsReports"));
const NfcAdminCards = React.lazy(() => import("./screens/SuperAdmin/NFC/NFC"));
const NfcCards = React.lazy(() => import("./screens/NFC/NfcScreen"));

const NfcDetail = React.lazy(() => import("./screens/NFC/Detail/NfcDetail"));
const NfcDetailAdmin = React.lazy(
  () => import("./screens/SuperAdmin/NFC/Detail/NfcDetail"),
);
const ProfileScreen = React.lazy(
  () => import("./screens/Profile/ProfileScreen"),
);

const ATMDetail = React.lazy(
  () => import("./screens/AtmsReport/Detail/AtmDetail"),
);

const CashDrops = React.lazy(
  () => import("./screens/SuperAdmin/CashDrops/CashDrops"),
);

const Customers = React.lazy(
  () => import("./screens/SuperAdmin/Customers/Customers"),
);

const Recharges = React.lazy(
  () => import("./screens/SuperAdmin/CardsLoads/CardsLoads"),
);

const CustomerDetail = React.lazy(
  () => import("./screens/SuperAdmin/Customers/Detail/CustomerDetail"),
);

const VenueWallets = React.lazy(
  () => import("./screens/VenueWallets/VenueWallets"),
);

const VenueWalletsDetail = React.lazy(
  () => import("./screens/VenueWallets/Detail/VenueWalletDetail"),
);

const CardsList = React.lazy(() => import("./screens/SuperAdmin/Cards/Cards"));

const CardMovements = React.lazy(
  () => import("./screens/SuperAdmin/Cards/Movements/Movements"),
);

const NFCRecharges = React.lazy(
  () => import("./screens/NFCRecharges/NFCRecharges"),
);

const NFCSummaryRecharges = React.lazy(
  () => import("./screens/NFCSummaryRecharges/NFCSummaryRecharges"),
);

const CashlessSummary = React.lazy(
  () => import("./screens/Cashless/CashlessSummary/CashlessSummary"),
);

const SuperAdminCuts = React.lazy(
  () => import("./screens/SuperAdmin/Reports/Cuts/SuperAdminCuts"),
);

const HardwareAtm = React.lazy(
  () => import("./screens/SuperAdmin/HardwareAtm/HardwareAtm"),
);

const Terminals = React.lazy(
  () => import("./screens/SuperAdmin/TerminalsSection/Terminals/Terminals"),
);

const Sessions = React.lazy(
  () => import("./screens/SuperAdmin/TerminalsSection/Sessions/Sessions"),
);

const SuperAdminClients = React.lazy(
  () => import("./screens/SuperAdmin/Administration/Clients/Clients"),
);

const SuperAdminConcessions = React.lazy(
  () => import("./screens/SuperAdmin/Administration/Concessions/Concessions"),
);

const SuperAdminProducts = React.lazy(
  () => import("./screens/SuperAdmin/Administration/Products/Products"),
);

const SuperAdminOperacionProducts = React.lazy(
  () => import("./screens/SuperAdmin/Products/Products"),
);

const SuperAdminDispersions = React.lazy(
  () => import("./screens/SuperAdmin/Administration/Dispersions/Dispersions"),
);

const SuperAdminPayoutsInvoices = React.lazy(
  () =>
    import(
      "./screens/SuperAdmin/Administration/PayoutsInvoices/PayoutsInvoices"
    ),
);

const Onboarding = React.lazy(
  () =>
    import("./screens/SuperAdmin/Administration/Onboarding/Onboarding"),
);

const OnboardingDetail = React.lazy(
  () =>
    import(
      "./screens/SuperAdmin/Administration/OnboardingDetail/OnboardingDetail"
    ),
);

const OnboardingForm = React.lazy(
  () => import("./screens/OnboardingForm/OnboardingForm"),
);

const Reconciliation = React.lazy(
  () => import("./screens/Reports/Reconciliation/Reconciliation"),
);

const Resume = React.lazy(() => import("./screens/Reports/Resume/Resume"));

const Payments = React.lazy(
  () => import("./screens/Reports/Payments/Payments"),
);

const Tips = React.lazy(() => import("./screens/Reports/Tips/Tips"));

const TicketsCards = React.lazy(
  () => import("./screens/Cashless/TicketsCards/TicketsCards"),
);
const TicketCardDetail = React.lazy(
  () =>
    import("./screens/Cashless/TicketsCards/TicketCardDetail/TicketCardDetail"),
);

const Palms = React.lazy(
  () => import("./screens/SuperAdmin/Palms/Palms"),
);
const PalmDetail = React.lazy(
  () => import("./screens/SuperAdmin/Palms/PalmDetail/PalmDetail"),
);

const Addons = React.lazy(
  () => import("./screens/Configuration/Addons/Addons"),
);

const Bills = React.lazy(() => import("./screens/Bills/Bills"));

const BillsDetail = React.lazy(() => import("./screens/Bills/Detail/Detail"));

const SalesHistory = React.lazy(
  () => import("./screens/SalesHistory/SalesHistory"),
);

const Categories = React.lazy(
  () => import("./screens/SuperAdmin/Categories/Categories"),
);

const Images = React.lazy(
  () => import("./screens/SuperAdmin/Images/Images"),
);

const KitchenMonitoring = React.lazy(
  () => import("./screens/SuperAdmin/Monitoring/Kitchen/Kitchen"),
);

const RunnerMonitoring = React.lazy(
  () => import("./screens/SuperAdmin/Monitoring/Runner/Runner"),
);

const InventorySupplies = React.lazy(
  () => import("./screens/Inventory/InventorySupplies/InventorySupplies"),
);

const InventoryPresentations = React.lazy(
  () =>
    import("./screens/Inventory/InventoryPresentations/InventoryPresentations"),
);

const InventoryWarehouses = React.lazy(
  () => import("./screens/Inventory/InventoryWarehouses/InventoryWarehouses"),
);

const InventoryStock = React.lazy(
  () => import("./screens/Inventory/InventoryStock/InventoryStock"),
);

const InventoryMovements = React.lazy(
  () => import("./screens/Inventory/InventoryMovements/InventoryMovements"),
);

const InventoryTransfer = React.lazy(
  () => import("./screens/Inventory/InventoryTransfer/InventoryTransfer"),
);

const InventorySummary = React.lazy(
  () => import("./screens/Inventory/InventorySummary/InventorySummary"),
);

const InventoryProfit = React.lazy(
  () => import("./screens/Inventory/InventoryProfit/InventoryProfit"),
);

const PendingApprovals = React.lazy(
  () => import("./screens/Inventory/PendingApprovals/PendingApprovals"),
);

const PendingApprovalDetail = React.lazy(
  () => import("./screens/Inventory/PendingApprovals/Detail/PendingApprovalDetail"),
);

const TokenCodes = React.lazy(
  () => import("./screens/Tokens/TokenCodes/TokenCodes"),
);

const TokenCodeDetail = React.lazy(
  () => import("./screens/Tokens/TokenCodeDetail/TokenCodeDetail"),
);

const TokenRedemptions = React.lazy(
  () => import("./screens/Tokens/TokenRedemptions/TokenRedemptions"),
);

const Station = React.lazy(() => import("./screens/Orders/Station/Station"));
const RunnerStation = React.lazy(() => import("./screens/Orders/RunnerStation/RunnerStation"));

const CardTransactions = React.lazy(
  () => import("./screens/SuperAdmin/Transactions/BankCards/Transactions"),
);

const Cancellations = React.lazy(
  () => import("./screens/Cancellations/Cancellations"),
);

const CancellationDetail = React.lazy(
  () => import("./screens/Cancellations/Detail/CancellationDetail"),
);

const CancellationPendingApprovals = React.lazy(
  () => import("./screens/Cancellations/PendingApprovals/PendingApprovals"),
);

const CancellationPendingApprovalDetail = React.lazy(
  () =>
    import(
      "./screens/Cancellations/PendingApprovals/Detail/PendingApprovalDetail"
    ),
);

const ProcessorsPayments = React.lazy(
  () =>
    import(
      "./screens/SuperAdmin/CentroControl/ProcessorsPayments/ProcessorsPayments"
    ),
);

const TerminalsStatus = React.lazy(
  () => import("./screens/SuperAdmin/TerminalsSection/Status/TerminalsStatus"),
);

const TerminalStatusDetail = React.lazy(
  () =>
    import("./screens/SuperAdmin/TerminalsSection/Status/components/Detail"),
);

const ExplorePanel = React.lazy(
  () => import("./screens/ExplorePanel/ExplorePanel"),
);

const TerminalsCut = React.lazy(
  () => import("./screens/SuperAdmin/CentroControl/TerminalsCut/TerminalsCut"),
);

const GlobalSales = React.lazy(
  () => import("./screens/SuperAdmin/CentroControl/globalSales/globalSales"),
);

//declaramos el router con esas pantallas
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <RouteNotFound />,
  },
  {
    path: "/recuperarcontra",
    element: <RecoveryPassword />,
  },
  {
    path: "/seleccionarnegocio",
    element: <SelectBussines />,
  },
  {
    path: "/form/:hash",
    element: <OnboardingForm />,
  },
  {
    path: "/panel",
    element: (
      <ErrorBoundary>
        <Dashboard />
      </ErrorBoundary>
    ),
    children: [
      {
        path: "inicio",
        element: <Home />,
      },
      {
        path: "perfil",
        element: <ProfileScreen />,
      },
      {
        path: "misnegocios",
        element: <MyBusiness />,
      },
      {
        path: "misrecintos",
        element: <MyVenues />,
      },
      {
        path: "tokens/codigos",
        element: <TokenCodes />,
      },
      {
        path: "tokens/codigos/:uuid",
        element: <TokenCodeDetail />,
      },
      {
        path: "tokens/canjes",
        element: <TokenRedemptions />,
      },
      {
        path: "wallets",
        element: <VenueWallets />,
      },
      {
        path: "wallets/:uuid",
        element: <VenueWalletsDetail />,
      },
      {
        path: "atms",
        element: <AtmsReport />,
      },
      {
        path: "atms/:uuid",
        element: <ATMDetail />,
      },
      {
        path: "ordenes",
        element: <SalesOrders />,
      },
      {
        path: "ordenes/:uuid",
        element: <SalesDetail />,
      },
      {
        path: "cuentas",
        element: <Bills />,
      },
      {
        path: "cuentas/:uuid",
        element: <BillsDetail />,
      },
      {
        path: "cortes",
        element: <Cuts />,
      },
      {
        path: "conciliacion",
        element: <Reconciliation />,
      },
      {
        path: "historial",
        element: <SalesHistory />,
      },
      {
        path: "resumen",
        element: <Resume />,
      },
      {
        path: "pagos",
        element: <Payments />,
      },
      {
        path: "propinas",
        element: <Tips />,
      },
      {
        path: "productos",
        element: <TopProducts />,
      },
      {
        path: "vendedores",
        element: <TopSellers />,
      },
      {
        path: "concesiones",
        element: <TopConcessions />,
      },
      {
        path: "nfc",
        element: <NfcCards />,
      },
      {
        path: "nfc/:uuid",
        element: <NfcDetail />,
      },
      {
        path: "recargas_nfc",
        element: <NFCRecharges />,
      },
      {
        path: "recargadores",
        element: <NFCSummaryRecharges />,
      },
      {
        path: "cashless/corte",
        element: <CashlessSummary />,
      },
      {
        path: "cashless/tickets-tarjetas",
        element: <TicketsCards />,
      },
      {
        path: "cashless/tickets-tarjetas/:uuid",
        element: <TicketCardDetail />,
      },
      {
        path: "inventario-v2/insumos",
        element: <InventorySupplies />,
      },
      {
        path: "inventario-v2/presentaciones",
        element: <InventoryPresentations />,
      },
      {
        path: "inventario-v2/almacenes",
        element: <InventoryWarehouses />,
      },
      {
        path: "inventario-v2/stock",
        element: <InventoryStock />,
      },
      {
        path: "inventario-v2/movimientos",
        element: <InventoryMovements />,
      },
      {
        path: "inventario-v2/transferir",
        element: <InventoryTransfer />,
      },
      {
        path: "inventario-v2/resumen",
        element: <InventorySummary />,
      },
      {
        path: "inventario-v2/utilidades",
        element: <InventoryProfit />,
      },
      {
        path: "inventario-v2/aprobaciones-pendientes",
        element: <PendingApprovals />,
      },
      {
        path: "inventario-v2/aprobaciones-pendientes/:uuid",
        element: <PendingApprovalDetail />,
      },
      {
        path: "configuracion/depositos",
        element: <Deposits />,
      },
      {
        path: "configuracion/productos",
        element: <Products />,
      },
      {
        path: "configuracion/complementos",
        element: <Addons />,
      },
      {
        path: "configuracion/perfil",
        element: <Profile />,
      },
      {
        path: "configuracion/usuarios",
        element: <ConcessionUsers />,
      },
      {
        path: "usuarios-recinto",
        element: <VenueUsers />,
      },

      {
        path: "configuracion/puntosdeventa",
        element: <SalesPoints />,
      },
      {
        path: "configuracion/descuentos",
        element: <Discounts key="descuentos-uniconcession" />,
      },
      {
        path: "configuracion/promociones",
        element: <Promotions key="promociones-uniconcession" />,
      },
      {
        path: "configuracion/combos",
        element: <Combos />,
      },
      {
        path: "pedidos/estacion",
        element: <Station />,
      },
      {
        path: "entregas/estacion",
        element: <RunnerStation />,
      },
      {
        path: "terminales/status",
        element: <TerminalsStatus key="venue-terminals-status" />,
      },
      {
        path: "terminales/status/detalle/:uuid",
        element: <TerminalStatusDetail />,
      },
      {
        path: "superadmin",
        element: <Navigate to="/panel/inicio" replace />,
      },
      {
        path: "superadmin/eventos",
        element: <Events />,
      },
      {
        path: "superadmin/concesiones",
        element: <Concessions />,
      },
      {
        path: "superadmin/promociones-multiconcesion",
        element: <Promotions key="promociones-multiconcession" />,
      },
      {
        path: "superadmin/descuentos-multiconcesion",
        element: <Discounts key="descuentos-multiconcession" />,
      },
      {
        path: "superadmin/clientes",
        element: <Clients />,
      },
      {
        path: "superadmin/usuarios",
        element: <UsersList />,
      },

      {
        path: "superadmin/temporadas",
        element: <Seasons />,
      },
      {
        path: "superadmin/atms",
        element: <Atms />,
      },
      {
        path: "superadmin/atms/:uuid",
        element: <CreateAtm />,
      },
      {
        path: "superadmin/reportes/resumen",
        element: <YoshiSummary />,
      },
      {
        path: "superadmin/reportes/resumen/:eventId",
        element: <YoshiSummaryEventDetail />,
      },
      {
        path: "superadmin/reportes/clientes",
        element: <Customers />,
      },
      {
        path: "superadmin/saldo",
        element: <Recharges />,
      },
      {
        path: "superadmin/reportes/clientes/:uuid",
        element: <CustomerDetail />,
      },
      {
        path: "superadmin/nfc",
        element: <NfcAdminCards />,
      },
      {
        path: "superadmin/nfc/:uuid",
        element: <NfcDetailAdmin />,
      },
      {
        path: "superadmin/tarjetas",
        element: <CardsList />,
      },
      {
        path: "superadmin/tarjetas/:uuid",
        element: <CardMovements />,
      },
      {
        path: "superadmin/manos",
        element: <Palms />,
      },
      {
        path: "superadmin/manos/:uuid",
        element: <PalmDetail />,
      },
      {
        path: "superadmin/reportes/cortes",
        element: <SuperAdminCuts />,
      },
      {
        path: "superadmin/cajeros",
        element: <HardwareAtm />,
      },

      {
        path: "superadmin/terminales/dispositivos",
        element: <Terminals />,
      },
      {
        path: "superadmin/terminales/sesiones",
        element: <Sessions />,
      },
      {
        path: "superadmin/terminales/status",
        element: <TerminalsStatus key="superadmin-terminals-status" />,
      },
      {
        path: "superadmin/terminales/status/detalle/:uuid",
        element: <TerminalStatusDetail />,
      },
      {
        path: "superadmin/admin/clientes",
        element: <SuperAdminClients />,
      },
      {
        path: "superadmin/admin/concesiones",
        element: <SuperAdminConcessions />,
      },
      {
        path: "superadmin/admin/productos",
        element: <SuperAdminProducts />,
      },
      {
        path: "superadmin/operacion/productos",
        element: <SuperAdminOperacionProducts />,
      },
      {
        path: "superadmin/admin/dispersiones",
        element: <SuperAdminDispersions />,
      },
      {
        path: "superadmin/admin/dispersiones/pagos-facturas/:uuid",
        element: <SuperAdminPayoutsInvoices />,
      },
      {
        path: "superadmin/admin/conciliacion",
        element: <Reconciliation />,
      },
      {
        path: "superadmin/admin/pagos",
        element: <Payments />,
      },
      {
        path: "superadmin/admin/onboarding",
        element: <Onboarding />,
      },
      {
        path: "superadmin/admin/onboarding/:uuid",
        element: <OnboardingDetail />,
      },
      {
        path: "superadmin/categorias",
        element: <Categories />,
      },
      {
        path: "superadmin/imagenes",
        element: <Images />,
      },
      {
        path: "superadmin/monitoreo/cocina",
        element: <KitchenMonitoring />,
      },
      {
        path: "superadmin/monitoreo/runners",
        element: <RunnerMonitoring />,
      },
      {
        path: "superadmin/transacciones/tarjetas",
        element: <CardTransactions />,
      },
      {
        path: "superadmin/transacciones/tarjetas/:uuid",
        element: <SaleDetail />,
      },
      {
        path: "superadmin/centrocontrol/procesadores",
        element: <ProcessorsPayments />,
      },
      {
        path: "superadmin/centrocontrol/terminales",
        element: <TerminalsCut />,
      },
      {
        path: "superadmin/centrocontrol/ventaglobal",
        element: <GlobalSales />,
      },
      {
        path: "superadmin/entregaefectivo",
        element: <CashDrops />,
      },
      {
        path: "superadmin/cancelaciones",
        element: <Cancellations />,
      },
      {
        path: "superadmin/aprobaciones-de-cancelacion",
        element: <CancellationPendingApprovals />,
      },
      {
        path: "superadmin/aprobaciones-de-cancelacion/:uuid",
        element: <CancellationPendingApprovalDetail />,
      },
      {
        path: "superadmin/cancelaciones/:uuid",
        element: <CancellationDetail />,
      },
      {
        path: "cancelaciones",
        element: <Cancellations />,
      },
      {
        path: "aprobaciones-de-cancelacion",
        element: <CancellationPendingApprovals />,
      },
      {
        path: "aprobaciones-de-cancelacion/:uuid",
        element: <CancellationPendingApprovalDetail />,
      },
      {
        path: "cancelaciones/:uuid",
        element: <CancellationDetail />,
      },
      {
        path: "explorar",
        element: <ExplorePanel />,
      },
    ],
  },
]);

export default function RouterProv() {
  return <RouterProvider router={router} />;
}
